export default "__VITE_ASSET__CIkj_hdY__"